// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".send-request-reply-facility .facility-category[data-v-1f2ba314]{font-size:14px}.send-request-reply-facility .facility-name[data-v-1f2ba314]{font-size:16px;font-weight:700}.send-request-reply-facility .facility-address[data-v-1f2ba314],.send-request-reply-facility .facility-url[data-v-1f2ba314]{font-size:14px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
